module.exports = __webpack_public_path__ + "assets/img/img-video-border.3d712e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/img-video-border.png
// module id = 418
// module chunks = 1